const base_url = process.env.REACT_APP_API_URL;

// Chatbot (loan-bot) now runs under the regular portal API base, same as every other endpoint.
// base_url already ends with a trailing slash (e.g. https://dev-customerapi.servicehqtrs.com/),
// so the path must NOT start with one — otherwise the URL gets a double slash.
const chatbot_url = base_url + 'chat-bot/loan-bot';

export const api_urls = {
    getConigDetails: '/brands/get-brand',
    ValidateContractId: base_url + 'login/validate-contract-id',
    FindUserEmailByContractId: base_url + 'login/find-user-email-by-contract-id',

    // API's for Registration
    Register: base_url + 'register',
    VerifyRegistrationOtp: base_url + 'register/verify-otp',
    ResendOtp: base_url + 'register/resend-otp',
    SetUserPassword: base_url + 'register/set-register-password',
    RegistrationSecurityCheck: base_url + 'register/security-questions',
    VerifyRegistrationFormDetails: base_url + 'register/verify-details',
    ValidateActivationLink: base_url + 'register/validate-activation-link',

    // API's for Login
    Login: base_url + 'auth/login',
    SendLoginOtp: base_url + 'auth/login/send-otp',
    ResendLoginOtp: base_url + 'auth/login/resend-otp',
    SelfVerifyPhoneSendOtp: base_url + 'auth/self-verify-phone/send-otp',
    SelfVerifyPhoneConfirm: base_url + 'auth/self-verify-phone/confirm',
    UpdatePhoneInitiate: base_url + 'auth/update-phone-number/initiate',
    UpdatePhoneVerifyOtp: base_url + 'auth/update-phone-number/verify-otp',
    VerifyLoginOtp: base_url + 'auth/login/verify-otp',

    // API's for Forgot Password
    ForgotPassword: base_url + 'auth/forgot-password',
    VerifyForgotPasswordOtp: base_url + 'auth/forgot-password/verify-otp',
    ResetForgotPassword: base_url + 'auth/forgot-password/reset',

    // API for Contracts
    GetContractActiveList: base_url + 'contracts/user-contracts',
    GetContractById: base_url + 'contracts',
    GetContractAmortization: base_url + 'contracts/contract-amortization',
    GetAssets: base_url + 'assets',
    SupportContractList: base_url + 'contracts/list-contracts',

    // API for Payments
    GetPaymentHistory: base_url + 'payments/history',
    MakePayment: base_url + 'payments',
    MakeBulkPayment: base_url + 'payments/bulk',
    GetUserBasedPaymentHistory: base_url + 'payments/history',
    UpcomingPayments: base_url + 'payments/open-invoices',
    GetScheduledPayments: base_url + 'payments',
    CancelScheduledPayment: base_url + 'payments',
    GetStripePaymentMethods: base_url + 'payments/stripe/payment-methods',
    CreateStripeSetupIntent: base_url + 'payments/stripe/setup-intent',
    CreateStripePaymentIntents: base_url + 'payments/stripe/payment-intents',
    CreateBulkStripePaymentIntents: base_url + 'payments/stripe/bulk-payment-intents',
    GetPaymentFees: base_url + 'payments/fees',

    // API for Ello AI Payments
    ElloAiPaymentDetails: base_url + 'payments/elloai/details',
    ElloAiPaymentConfirm: base_url + 'payments/elloai/confirm',

    // API for Documents
    GetDocumentsList: base_url + 'documents/listall-documents',
    GetDocumentPreview: base_url + 'documents/preview-document',
    UploadDocument: base_url + 'documents/upload',
    GetAllEnabledFileExtensions: base_url + 'documents/list-extensions',

    // API for Refresh Token
    RefreshToken: base_url + 'auth/refresh',
    Logout: base_url + 'auth/logout',

    // API for Profile
    GetProfileDetails: base_url + 'users/user-details',
    UploadProfilePicture: base_url + 'users/upload-profile-pic',
    ChangePassword: base_url + 'users/change-password',
    UpdateNotificationPreferences: base_url + 'users/update-notifications-enabling',
    AddPhoneNumber: base_url + 'users/add-phone-number',
    VerifyPhoneOtp: base_url + 'users/verify-phone-otp',
    ResendphoneOtp: base_url + 'users/resend-phone-otp',
    UpdateUserDetails: base_url + 'users/update',

    //API for support
    CreateSupportTicket: base_url + 'support/createticket',
    SupportList: base_url + 'support/supportlist',
    // SupportContractList: base_url + 'contracts/list-contracts',
    SupportRequestType: base_url + 'support/request-types',
    SupportFaqsList: base_url + 'faqs/getfaqs',

    // API for Bank Accounts
    GetBankAccounts: base_url + 'bank-accounts',
    CreateBankAccounts: base_url + 'bank-accounts',
    UpdateBankAccountStatus: base_url + 'bank-accounts',
    // GET {base}/{id}/account-number — returns the encrypted full account number (unmask)
    GetBankAccountNumber: base_url + 'bank-accounts',

    //enable autopay
    UpdateEnableAutoPay: base_url + 'contracts/enable-auto-pay',

    // dashboard
    GetDashboardData: base_url + 'dashboard/get-customer-dashboard',

    // notifications
    GetUserNotificationsCount: base_url + 'notifications/unread-count',
    GetAllNotifications: base_url + 'notifications',

    // API for Migration
    CheckEmailForMigration: base_url + 'auth/migration/check-email',
    VerifyOtpForMigration: base_url + 'auth/migration/verify-otp',
    SetPasswordForMigration: base_url + 'auth/migration/set-password',

    // API for Chatbot
    ChatbotLoanBot: chatbot_url,

    // API for admin-assisted registration invite (link click-through on customer-app)
    CompleteRegistrationDetails: base_url + 'admin-registration/invite',
};
